import { isDevEnvironment } from '@workspace/lib/utils/app-env';

import type { AppPathname } from '@/i18n/routing';

// Test-only protection switch: the cookie is honored only on dev environments
// (NEXT_PUBLIC_APP_ENV=development), so protection can never be disabled on
// ppd/prod via a cookie.
export const ROUTE_PROTECTION_COOKIE = 'route-protection';

export const ROUTE_PROTECTION_STATES = ['on', 'off'] as const;
export type RouteProtectionState = (typeof ROUTE_PROTECTION_STATES)[number];

/**
 * Internal routes reachable without an SSO session. Everything else —
 * including future routes and paths outside the routing map — requires
 * authentication (deny by default).
 */
export const PUBLIC_ROUTES: readonly AppPathname[] = [
  '/', // dev/QA test index; non-dev envs redirect it to /person-details
  '/person-details',
  '/technical-error',
];

export const isRouteProtectionDisabled = (switchCookieValue?: string) =>
  isDevEnvironment && switchCookieValue === 'off';
